export default __webpack_public_path__ + "824c861241007531f93c19159ce89eb0.png";